import FormConfig from "../ConfigurationFormConfig";

/**
 * FKWizardManager (DWA-A 138-1)
 *
 * Responsibility:
 * - Step 3: decision if fK is available
 * - If yes: persist `fK` + `fKIsManual` and skip Step 4/5
 */
export default class FKWizardManager {
    /**
     * @param {jQuery} form
     * @param {Object} state
     * @param {Object} host instance of ConfigurationForm
     */
    constructor(form, state, host) {
        this.form = form;
        this.state = state;
        this.host = host;

        this.$step = $('#fKStep3');
        this.$wrapper = this.$step.closest('.fKWizardStep3');

        this.$fOrtStep4 = $('.fortWizardStep4');
        this.$fOrtStep5 = $('.fortWizardStep5');

        this.wasActive = false;
    }

    init() {
        if (!this.$step.length) {
            return;
        }
        this.bindHandlers();
        this.updateVisibility();
        this.syncFromPersisted();
    }

   	bindHandlers() {
		this.form.on('change', '#fKStep3 .fKDecision', e => {
			this.form.find('#fKStep3 .fKDecision').not(e.target).prop('checked', false);

			const decision = this.getDecision();
			if (decision === 1) {
				this.setFKIsManual(true);
				this.$step.find('.fKValueRow').show();
				this.$step.find('.fKInput').prop('required', true);
				this.recomputeFK();
			} else if (decision === 0) {
				this.setFKIsManual(false);
				// Clear manual fK; it will be derived later
				this.setFK(0);
				this.clearFKValidity();
				this.$step.find('.fKValueRow').hide();
				this.$step.find('.fKInput').prop('required', false).val('');
			}

			this.updateVisibility();
			this.triggerDownstreamUpdate();
		});

		this.form.on('input', '#fKStep3 .fKInput', () => {
			if (this.getDecision() === 1) {
				this.recomputeFK();
			}
		});

		const slide = $(FormConfig.selectors.fkSlide);
		slide.find('input').on('change', e => {
			// check if this event was triggered manually via user action
			// do not clear slides if this was triggered programmatically i.e. via FMethodeManager
			if(e.hasOwnProperty('originalEvent')) {
				this.host.clearSlides(slide.nextAll(FormConfig.selectors.slides))
			}
		});
	}

	triggerDownstreamUpdate() {
		// Downstream depends on fK decision
		if (this.host && this.host.fOrtQuestionManager && typeof this.host.fOrtQuestionManager.updateVisibility === 'function') {
			this.host.fOrtQuestionManager.updateVisibility();
		}
		if (this.host && this.host.fMethodeManager && typeof this.host.fMethodeManager.updateVisibility === 'function') {
			this.host.fMethodeManager.updateVisibility();
		}
	}

	updateVisibility() {
		const isActiveBase = (typeof this.host.isGuideline1381Active === 'function')
			? this.host.isGuideline1381Active()
			: false;

		const kiIsManual = this.getPersistedBool('.kiIsManual');
		const isActive = isActiveBase && !kiIsManual;
		console.log('[FKWizardManager] updateVisibility', { isActive, kiIsManual });

		if (!isActive) {
			if (this.wasActive) {
				this.reset();
			}
			if (typeof this.host.setInputsDisabled === 'function') {
				this.host.setInputsDisabled(this.$wrapper, true);
			}
			this.$step.hide();
			this.$wrapper.hide();
			this.wasActive = isActive;
			return;
		}

		this.$wrapper.show();
		this.$step.show();
		if (typeof this.host.setInputsDisabled === 'function') {
			this.host.setInputsDisabled(this.$wrapper, false);
		}

		// Skip Step 4/5 if fK is manual; otherwise re-enable them and let Step4/5 manager decide.
		const fKIsManual = this.getPersistedBool('.fKIsManual');
		console.log('[FKWizardManager] fKIsManual check', { fKIsManual, kiIsManual });

		if (fKIsManual || kiIsManual) {
			this.$fOrtStep4.hide();
			this.host.setInputsDisabled(this.$fOrtStep4, true);
			this.$fOrtStep5.hide();
			this.host.setInputsDisabled(this.$fOrtStep5, true);
		} else {
			this.$fOrtStep4.show();
			this.host.setInputsDisabled(this.$fOrtStep4, false);
			this.$fOrtStep5.show();
			this.host.setInputsDisabled(this.$fOrtStep5, false);
			if (this.host && this.host.fOrtQuestionManager && typeof this.host.fOrtQuestionManager.updateVisibility === 'function') {
				this.host.fOrtQuestionManager.updateVisibility();
			}
		}

		this.wasActive = isActive;
	}

    syncFromPersisted() {
        const fKIsManual = this.getPersistedBool('.fKIsManual');
        console.log('[FKWizardManager] syncFromPersisted', { fKIsManual });
        if (fKIsManual === true) {
            this.form.find('#fKStep3 .fKDecision[value="1"]').prop('checked', true);
            this.$step.find('.fKValueRow').show();
            this.$step.find('.fKInput').prop('required', true);

            // Recover value from hidden field
            const $field = this.form.find('input.fKValue').first();
            const val = parseFloat($field.val() || '0');
            if (val > 0) {
                this.$step.find('.fKInput').val(val.toFixed(2).replace('.', ','));
                // Set sidebar result display if needed (no explicit result span in FK step usually)
            }
        } else if (fKIsManual === false) {
            this.form.find('#fKStep3 .fKDecision[value="0"]').prop('checked', true);
            this.$step.find('.fKValueRow').hide();
            this.$step.find('.fKInput').prop('required', false);
        } else {
            // Default: if it's explicitly guideline 138-1 and no value set, pre-select "No"
            const isActive = (typeof this.host.isGuideline1381Active === 'function')
                ? this.host.isGuideline1381Active()
                : false;
            console.log('[FKWizardManager] syncFromPersisted fallback', { isActive });
            if (isActive) {
                this.form.find('#fKStep3 .fKDecision[value="0"]').prop('checked', true);
                this.setFKIsManual(false);
            }
        }
    }

    getDecision() {
        const $checked = this.form.find('#fKStep3 .fKDecision:checked');
        if ($checked.length) {
            return parseInt($checked.val(), 10);
        }
        return null;
    }

   	recomputeFK() {
		const $input = this.$step.find('.fKInput');
		const inputEl = $input.length ? $input[0] : null;
		const message = String($input.data('validationmessage') || '');
		const raw = String($input.val() || '').trim();

		// Enforce required + format + range (0.03–1.00, optional 1–2 decimals)
		if (raw === '') {
			if (inputEl && typeof inputEl.setCustomValidity === 'function') {
				inputEl.setCustomValidity(message || '');
			}
			this.setFK(0);
			return;
		}

		const normalized = raw.replace(',', '.');
		const formatOk = /^\d+(?:\.\d{1,2})?$/.test(normalized);
		const value = parseFloat(normalized);
		const rangeOk = !isNaN(value) && value >= 0.03 && value <= 1.0;
		if (!formatOk || !rangeOk) {
			if (inputEl && typeof inputEl.setCustomValidity === 'function') {
				inputEl.setCustomValidity(message || '');
			}
			this.setFK(0);
			return;
		}

		if (inputEl && typeof inputEl.setCustomValidity === 'function') {
			inputEl.setCustomValidity('');
		}
		this.setFK(value);
	}

	clearFKValidity() {
		const $input = this.$step.find('.fKInput');
		const inputEl = $input.length ? $input[0] : null;
		if (inputEl && typeof inputEl.setCustomValidity === 'function') {
			inputEl.setCustomValidity('');
		}
	}

    setFK(value) {
        const $field = this.form.find('input.fKValue').first();
        if (!$field.length) {
            return;
        }
        $field.val(String(value));
        $field.trigger('change');
    }

    setFKIsManual(enabled) {
        const $field = this.form.find('input.fKIsManual').first();
        if (!$field.length) {
            return;
        }
        $field.val(enabled ? '1' : '0');
    }

    getPersistedBool(selector) {
        const $field = this.form.find(selector).first();
        if (!$field.length) {
            return null;
        }
        const raw = String($field.val() || '').trim();
        if (raw === '') {
            return null;
        }
        return raw === '1' || raw === 'true';
    }

    reset() {
        this.form.find('#fKStep3 .fKDecision').prop('checked', false);
        this.$step.find('.fKInput').val('').prop('required', false);
        this.$step.find('.fKValueRow').hide();
        this.setFKIsManual(false);
        this.setFK(0);
    }
}
